import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const RouterBlock = () => {
  const location = useLocation();
  const hasMounted = useRef(false);

  useEffect(() => {
    const navEntry = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming;
    const navType = navEntry?.type;

    if (navType === 'reload') {
      sessionStorage.removeItem('initialReferrer');
      return;
    }

    if (!hasMounted.current) {
      hasMounted.current = true;

      const referrer = document?.referrer;
      const isSameOrigin = referrer.startsWith(window.location.origin);

      if (referrer && !isSameOrigin) {
        sessionStorage.setItem('initialReferrer', referrer);
      }

      return;
    }

    sessionStorage.removeItem('initialReferrer');
  }, [location.pathname]);

  return null;
};

export default RouterBlock;
